import * as Yup from "yup";

export const emailAuthenticationResponseSchema = Yup.object({
  message: Yup.string(),
});

export type EmailAuthenticationResponse = Yup.InferType<
  typeof emailAuthenticationResponseSchema
>;
